module.exports = __webpack_public_path__ + "static/media/addContactIcon.1e3cf7d8.svg";